export const ONE_TIME_SUBMISSION = 'One Time Submission';
export const MULTIPLE_SUBMISSION = 'Multiple Submission';
export const OVERWRITE_EXISTING_SESSION = 'Overwrite Existing Session';
